export { default as WishLists } from "./pages/wishList/index.jsx";
export { default as LastVisits } from "./pages/lastVisit/index.jsx";
